export const manualInvoiceModal = {
  modalTitle: {
    create: "Crear factura manualmente",
    correcting: "Corregir datos de factura",
  },
  confirm: {
    title: "Revisa antes de crear",
    subtitle:
      "Se creará un borrador. Podrás revisarlo, añadir cargos y emitirlo cuando quieras.",
    rowDocument: "Documento",
    documentValue: "Borrador · número al emitir",
    rowType: "Tipo",
    typeCompany: "Empresa / Jurídica",
    typeIndividual: "Particular",
    labelCompanyName: "Razón social",
    labelName: "Nombre",
    rowCountry: "País",
    rowEmail: "Email",
    rowAddress: "Dirección",
    rowPayment: "Pago",
    rowNotes: "Notas",
  },
  info: {
    createTitle: "Se creará un BORRADOR de factura (sin número hasta emitir).",
    correctingTitle: "Corrección de datos fiscales",
    createBody:
      "Se guardará como borrador. Podrás añadir cargos y, cuando esté lista, emitirla — el número correlativo lo asigna Hacienda al emitir.",
    correctingBody:
      "Modifica únicamente los datos que necesitas corregir. Se generará una <strong>factura rectificativa</strong> con los datos correctos.",
  },
  prefillLoading: "Cargando datos fiscales del huésped…",
  // Facturar toda la reserva o una sola habitación (reservas de varias).
  scope: {
    lead: "Esta reserva tiene varias habitaciones. ¿Qué factura quieres crear?",
    continue: "Continuar",
    label: "¿Cómo quieres facturar?",
    whole: "Toda la reserva",
    wholeHint: "Una sola factura con las {n} habitaciones.",
    perRoom: "Una habitación",
    perRoomHint: "Cada habitación, su factura: sus noches y sus cargos.",
    pickRoom: "Elige la habitación",
    repeatHint: "Repite esto con cada habitación para que cada huésped tenga la suya.",
  },

  recipientType: {
    label: "Tipo de destinatario",
    individual: "Particular",
    individualSub: "Persona física",
    company: "Empresa",
    companySub: "Persona jurídica",
    active: "Activo",
  },
  // Buscador de clientes del fichero dentro del modal: evita teclear a mano
  // una empresa que ya está guardada.
  client: {
    label: "Cliente guardado",
    help: "Busca un cliente del fichero y sus datos fiscales se rellenan solos. Si no está, escribe los datos a mano.",
    clear: "Quitar",
    linkedHint: "Datos traídos de su ficha. Puedes corregir cualquier campo sin perder el enlace con el cliente.",
    noFiscalProfile: "Ese cliente no tiene perfil fiscal guardado: hemos traído su nombre y su email, el resto hay que escribirlo (o completar su ficha en Clientes).",
  },
  fields: {
    nameCompany: "Razón social *",
    nameIndividual: "Nombre completo *",
    country: "País",
    countryPlaceholder: "Selecciona el país del huésped",
    countryHint: "Indica el país fiscal del huésped para la factura.",
    optional: "(opcional)",
    emailLabel: "Email de facturación",
    phoneLabel: "Teléfono",
    addressLabel: "Dirección fiscal",
    sectionInvoiceData: "Datos de la factura",
    paymentSourceLabel: "Procedencia del pago",
    paymentHintPrefilled:
      "Marcado a partir de los cobros que registraste. Cámbialo si no es correcto.",
    paymentHintMulti:
      "Puedes marcar varios si la estancia se cobró de más de una forma.",
    paymentHintNone: "Sin marcar nada, la factura no dirá cómo se cobró.",
    seriesLabel: "Serie",
    seriesHint: "Esta serie viene desde la configuración de facturación.",
    notesLabel: "Detalle adicional para la factura",
    notesHint:
      "Úsalo para añadir concepto libre, aclaraciones o detalles extra de la emisión.",
  },
  preview: {
    label: "Siguiente correlativo",
    estHint: "informativo · se asigna al emitir (el primero que emita se lo lleva)",
    noNumber: "Se asigna al emitir · el borrador va sin número",
  },
  footer: {
    cancel: "Cancelar",
    create: "Crear factura",
    editData: "Editar datos",
    creating: "Creando...",
    createDraft: "Crear borrador",
  },
  success: {
    title: "¡Factura emitida!",
    badge: "Emitida",
    pdfGenerating: "El PDF se está generando. Puede tardar unos segundos.",
    downloadPdf: "Descargar factura PDF",
    generatingPdf: "Generando PDF…",
    sendWhatsapp: "Enviar por WhatsApp",
    closeWindow: "Cerrar ventana",
  },
  paymentSource: {
    cash: "Efectivo",
    card: "Tarjeta de crédito",
    transfer: "Transferencia bancaria",
    otherOta: "Pagado por otra OTA",
  },
  prefill: {
    clientFile:
      "Datos tomados de la ficha del cliente. Revísalos antes de crear el borrador.",
    invoiceRecipient: "Datos precargados desde la última factura del huésped.",
    chat: "Datos fiscales que el huésped indicó al solicitar su factura. Revísalos y emite.",
    checkin:
      "Precargamos el nombre y el email del huésped desde su check-in. Completa abajo sus datos fiscales.",
    reservation:
      "No había datos fiscales completos; se usan los datos básicos de la reserva como base.",
    existingInvoice:
      "Datos precargados desde la factura existente. Modifica lo que necesites corregir.",
  },
  status: {
    sent: "Emitida",
    processing: "Procesando",
    pending: "Pendiente",
    error: "Error",
  },
  toast: {
    whatsappSent: "Factura enviada por WhatsApp.",
    whatsappError: "No se pudo enviar la factura por WhatsApp.",
    draftCreated: "Borrador creado. Revísalo y emítelo cuando esté listo.",
  },
  validation: {
    nameRequired: "El nombre o razón social es obligatorio.",
    countryInvalid: "Selecciona un país válido.",
    emailInvalid: "Introduce un email válido.",
    taxIdRequired:
      "Este identificador fiscal es obligatorio para este tipo de destinatario.",
  },
  errors: {
    conflict: "La reserva ya tiene una factura creada.",
    checkData: "Revisa los datos de facturación.",
    createFailed: "No se pudo crear la factura.",
  },
  taxId: {
    labels: {
      esCompany: "NIF empresa",
      brIndividual: "CPF o RG",
      defaultIndividual: "Número de identificación fiscal",
      defaultCompany: "Número fiscal",
    },
    hints: {
      esIndividual:
        "DNI o NIE (X1234567A). El pasaporte no es un identificador fiscal válido.",
      esCompany: "NIF/CIF de empresa.",
      ptIndividual: "9 dígitos.",
      ptCompany: "9 dígitos.",
      coIndividual: "6-10 dígitos.",
      coCompany: "NIT con dígito de verificación.",
      mxIndividual: "RFC persona física.",
      mxCompany: "RFC persona moral.",
      arIndividual: "11 dígitos con verificador.",
      arCompany: "11 dígitos con verificador.",
      clIndividual: "Con dígito verificador.",
      clCompany: "Con dígito verificador.",
      peIndividual: "8 dígitos.",
      peCompany: "11 dígitos.",
      ecIndividual: "10 dígitos.",
      ecCompany: "13 dígitos.",
      brIndividual:
        "CPF válido para facturación fiscal. Si indicas RG, se guardará como documento local del huésped.",
      brCompany: "14 dígitos.",
      defaultIndividual: "Opcional.",
      defaultCompany: "Obligatorio para empresa.",
    },
  },
  address: {
    ES: { city: "Ciudad", state: "Provincia", zip: "C.P." },
    PT: { city: "Cidade", state: "Distrito", zip: "C.P." },
    CO: { city: "Ciudad", state: "Dpto.", zip: "C.P." },
    MX: { city: "Ciudad", state: "Estado", zip: "C.P." },
    AR: { city: "Ciudad", state: "Provincia", zip: "C.P." },
    CL: { city: "Ciudad", state: "Región", zip: "C.P." },
    BR: { city: "Cidade", state: "Estado", zip: "CEP" },
    US: { city: "City", state: "State", zip: "ZIP" },
    GB: { city: "City", state: "County", zip: "Postcode" },
    DEFAULT: { city: "Ciudad", state: "Región", zip: "C.P." },
  },
  taxErrors: {
    cifCompany: "NIF/CIF de empresa inválido.",
    esIndividual: "Documento inválido. Introduce un DNI, NIE (X1234567A) o pasaporte.",
    ptNif: "NIF inválido. Debe tener 9 dígitos válidos.",
    nit: "NIT inválido.",
    coCedula: "Cédula inválida. Entre 6 y 10 dígitos.",
    rfc: "RFC inválido.",
    cuit: "CUIT inválido.",
    cuilCuit: "CUIL/CUIT inválido.",
    rut: "RUT inválido.",
    ruc: "RUC inválido.",
    peDni: "DNI inválido. Debe tener 8 dígitos.",
    ecCedula: "Cédula inválida.",
    cnpj: "CNPJ inválido.",
    brIndividual: "Documento inválido. Usa un CPF válido o un RG en formato habitual.",
  },
};
